module.exports = __webpack_public_path__ + "img/1557614094898503682.faf0f05d.png";